import { api, cardApi } from '@/setup/api.js'
import moment from 'moment'
import Compressor from 'compressorjs';

function dataURItoBlob(dataURI) {
	// convert base64 to raw binary data held in a string
	// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	var byteString = atob(dataURI.split(',')[1]);

	// separate out the mime component
	var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

	// write the bytes of the string to an ArrayBuffer
	var ab = new ArrayBuffer(byteString.length);

	// create a view into the buffer
	var ia = new Uint8Array(ab);

	// set the bytes of the buffer to the correct values
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	// write the ArrayBuffer to a blob, and you're done
	var blob = new Blob([ab], {type: mimeString});
	return blob;

}

function getCurrentSeason (){
	let currentYear = moment().year()
	let season = (moment().isBetween(`${currentYear}-03-20`, `${currentYear}-10-31`)) ? 'sommer' : 'winter'
	return season
}

export default {
	fetchCompany: ( {commit}, args ) => {
		// console.log('fetching companies...',args)
		if (args !== undefined && args.id !== undefined) {
			let fetchUrl = `/company/${args.id}`

			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: fetchUrl
				})
					.then(response => {
						if (response.status === 200 && response.data !== undefined) {
							// console.log('action - fetchCompany: ',response.data)
							commit('FETCH_COMPANY', response)
							resolve(response.data)
						}
					})
					.catch(err => {
						console.error(err)
						reject()
					})
			})
		} else {
			return null
		}
	},
	fetchSalepoint: ( {commit}, args ) => {
		if (args !== undefined && args.id !== undefined) {
			let fetchUrl = `/salespoint/${args.id}`

			return new Promise((resolve, reject) => {
				api({
					method: 'get',
					url: fetchUrl
				})
					.then(response => {
						if (response.status === 200 && response.data !== undefined) {
							commit('FETCH_SALESPOINT', response)
							resolve()
						}
					})
					.catch(err => {
						console.error(err)
						reject()
					})
			})
		} else {
			return null
		}
	},
	fetchCompanies: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/companies`

		return new Promise((resolve, reject) => {
			api({
				method: 'get',
				url: fetchUrl
			})
				.then(response => {
					if (response.status === 200 && response.data !== null && response.data.length >= 1) {
						commit('FETCH_COMPANIES', response)
						resolve()
					}
				})
				.catch(err => {
					console.error(err)
					reject(err)
				})
		})
	},
	fetchNearbyCompanies: async ( { commit }, args) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let lat = (args !== undefined && args.coords !== undefined && args.coords.lat !== undefined) ? args.coords.lat : null
		let lng = (args !== undefined && args.coords !== undefined && args.coords.lng !== undefined) ? args.coords.lng : null
		let fetchUrl = `${lang}/${season}/companies/nearby/${lng}/${lat}`

		return new Promise((resolve, reject) => {
			if (lat !== null && lng !== null) {
				api({
					method: 'get',
					url: fetchUrl
				})
					.then(response => {
						if (response.status === 200 && response.data !== null ) {
							commit('FETCH_COMPANIES', response)
							resolve()
						}
					})
					.catch(err => {
						console.error(err)
						reject()
					})
			} else {
				reject()
			}
		})
	},
	fetchNearbySalespoints: async ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let lat = (args !== undefined && args.coords !== undefined && args.coords.lat !== undefined) ? args.coords.lat : null
		let lng = (args !== undefined && args.coords !== undefined && args.coords.lng !== undefined) ? args.coords.lng : null
		let fetchUrl = `${lang}/${season}/salespoints/nearby/${lng}/${lat}`

		return new Promise((resolve, reject) => {
			if (lat !== null && lng !== null) {
				api({
					method: 'get',
					url: fetchUrl
				})
					.then(response => {
						if (response.status === 200 && response.data !== null ) {
							commit('FETCH_SALESPOINTS', response)
							resolve()
						}
					})
					.catch(err => {
						console.error(err)
						reject()
					})
			} else {
				reject()
			}
		})
	},
	fetchCategories: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/categories`

		api({
			method: 'get',
			url: fetchUrl
		})
			.then(response => {
				if (response.status === 200 && response.data.length >= 1) {
					commit('FETCH_CATEGORIES', response)
				}
			})
			.catch(err => {
				console.error(err)
			})
	},
	fetchCriterias: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/criterias`

		api({
			method: 'get',
			url: fetchUrl
		})
			.then(response => {
				if (response.status === 200 && response.data.length >= 1) {
					/*console.log("CRITERIAS")
					console.log(response);*/
					commit('FETCH_CRITERIAS', response)
				}
			})
			.catch(err => {
				console.error(err)
			})
	},
	fetchBonusCategories: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/bonuscategories`

		api({
			method: 'get',
			url: fetchUrl
		})
			.then(response => {
				if (response.status === 200 && response.data.length >= 1) {
					commit('FETCH_BONUS_CATEGORIES', response)
				}
			})
			.catch(err => {
				console.error(err)
			})
	},
	fetchSalespoints: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/salespoints`

		return new Promise((resolve, reject) => {
			api({
				method: 'get',
				url: fetchUrl
			})
				.then(response => {
					if (response.status === 200 && response.data.length >= 1) {
						Object.assign(response, { meta: { language: lang, season: season } })
						commit('FETCH_SALESPOINTS', response)
						resolve()
					}
				})
				.catch(error => {
					console.error(error)
					reject()
				})
		})
	},
	fetchCardInfos: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/cardinfos`

		return new Promise((resolve, reject) => {
			api({
				method: 'get',
				url: fetchUrl
			})
				.then(response => {
					if (response.status === 200 && response.data.length >= 1) {
						Object.assign(response, { meta: { language: lang, season: season } })
						commit('FETCH_CARDINFOS', response)
					}
					resolve()
				})
				.catch(err => {
					console.error(err)
					reject(err)
				})
		})
	},
	fetchNews: ( { commit }, args ) => {
		let lang = (args !== undefined && args.lang !== undefined) ? args.lang : 'de'
		let season = (args !== undefined && args.season !== undefined) ? args.season : getCurrentSeason()
		let fetchUrl = `${lang}/${season}/newsposts`

		return new Promise((resolve,reject) => {
			api({
				method: 'get',
				url: fetchUrl
			})
				.then(response => {
					if (response.status === 200 && response.data.length >= 1) {
						commit('FETCH_NEWS', response)
						resolve()
					}
					reject(response)
				})
				.catch(err => {
					console.error(err)
					reject(err)
				})
		})
	},
	updateLanguage: ( { commit }, newLang ) => {
		commit('UPDATE_LANGUAGE', newLang)
	},
	updateSeason: ( { commit }, newSeason ) => {
		console.log('updateSeason: ', newSeason);
		commit('UPDATE_SEASON', newSeason)
	},
	fetchBookmarks: ({ dispatch, getters }) => {
		// console.log('fetchBookmarks for:', getters.getBookmarksBlank);
		let blankBookmarks = getters.getBookmarksBlank
		blankBookmarks.forEach(bookmarkObject => {
			if (bookmarkObject.type === 'company') {
				dispatch('fetchCompany', { id: bookmarkObject.id })
			} else if (bookmarkObject.type === 'salespoint') {
				dispatch('fetchSalepoint', { id: bookmarkObject.id })
			}
		})
	},
	updateCompanyLikes: ( { commit, dispatch, getters }, company ) => {
		let updateUrl = `company/${company.id}/like`

		let alreadyLiked = getters.hasCompanyAlreadyLiked(company.id)
		if (!alreadyLiked) {
			api({
				method: 'post',
				url: updateUrl
			})
				.then(response => {
					if (response.status === 200 && response.data.success) {
						dispatch('fetchCompany', { id: company.id })
		
						
						commit('ADD_TO_LIKED_COMPANIES', company.translations)
					} else {
						// do something
					}
				})
				.catch(err => {
					console.error(err)
				})
		}
	},
	updateCurrentPosition: async ( { commit }, currentPosition ) => {
		commit('UPDATE_CURRENT_POSITION', currentPosition)
	},
	createBookmark: ( { commit }, obj) => {
		commit('CREATE_BOOKMARK', obj)
	},
	removeBookmark: ( { commit }, obj) => {
		commit('REMOVE_BOOKMARK', obj)
	},
	registerCard: ( { commit, state }, args ) => {
		return new Promise((resolve, reject) => {
			if (args && args.cardNumber && args.cardPin) {
				let cards = Object.values(state.cards)
				let existingCard = cards.filter(card => {
					return card.cardNumber === parseInt(args.cardNumber)
				})[0]

				cardApi({
					method: 'get',
					url: `${args.cardNumber}/${args.cardPin}`
				})
					.then((response) => {
						console.log(response);
						if(response.status === 200 && !response.data.error) {
							let responseWithTimestamp = Object.assign(response.data, { expires: moment().add(2, 'minutes').toDate()})
							responseWithTimestamp.cardPin = args.cardPin	// Otti: Pin added to each card object during registration and/or update
							responseWithTimestamp.lastCardUpdate = moment().toDate()	// Otti: LastUpdate added to each card object during registration and/or update
							
							// Compress images
							if (responseWithTimestamp.imageType && responseWithTimestamp.image) {
								let base64 = `data:${responseWithTimestamp.imageType};base64,${responseWithTimestamp.image}`
								let blob = dataURItoBlob(base64) // image to blob

								new Compressor(blob, { // compress blob
									quality: 0.2,
									success(result) {
										var reader = new FileReader();
										reader.readAsDataURL(result); // blob to image
										reader.onloadend = function() {
											var base64Compressed = reader.result;                
											responseWithTimestamp.image = base64Compressed.split(',')[1]
	
											console.log('image compressed');
	
											if (existingCard !== undefined) {
												commit('UPDATE_CARD', responseWithTimestamp)
												return resolve('UPDATED_CARD')
											}
				
											commit('REGISTER_CARD', responseWithTimestamp)
											return resolve('REGISTERED_CARD')
										}
									},
									error(err) {
									console.log(err.message);
									},
								});
							} else {
								if (existingCard !== undefined) {
									commit('UPDATE_CARD', responseWithTimestamp)
									return resolve('UPDATED_CARD')
								}
	
								commit('REGISTER_CARD', responseWithTimestamp)
								return resolve('REGISTERED_CARD')
							}
						}
						if(response.status === 200 && response.data.error){
							return reject(response.data)
						}
					})
					.catch((err) => {
						console.error(err)
						return reject('SERVICE_ERROR')
					})
			} else {
				return reject('No arguments/wrong arguments supplied.')
			}
		})
	},
	removeCard: ( { commit }, id ) => {
		commit('REMOVE_CARD', id)
	},
	updateFilteredResultsCount: ({ commit }, obj) => {
		commit('UPDATE_FILTERED_RESULTS_COUNT', obj)
	},
	updateFilteredResults: ({ commit }, obj) => {
		commit('UPDATE_FILTERED_RESULTS', obj)
	},
	updateBrowser: ( { commit }, obj) => {
		commit('UPDATE_BROWSER', obj)
	},
	updateSelectedRange: ({ commit }, obj) => {
		commit('UPDATE_SELECTED_RANGE', obj)
	},
	updateSelectedCategories: ({ commit }, obj) => {
		commit('UPDATE_SELECTED_CATEGORIES', obj)
	},
	updateSelectedCriterias: ({ commit }, obj) => {
		commit('UPDATE_SELECTED_CRITERIAS', obj)
	},
	updateTopPerformanceSelection: ({ commit }, obj) => {
		commit('UPDATE_TOP_PERFORMANCE_SELECTION', obj)
	},
	resetFilter: ({ commit }, obj) => {
		commit('RESET_FILTER', obj)
	},
	updateEntity: ({ commit }, entity) => {
		commit('UPDATE_ENTITY', entity)
	},
	updateSalesEntity: ({ commit }, entity) => {
		commit('UPDATE_SALES_ENTITY', entity)
	},
	updateSeasonEntity: ({ commit }, entity) => {
		commit('UPDATE_SEASON_ENTITY', entity)
	}
}